
namespace RioERP.Users {
    export class CustomerAddressColumns {
        static columnsKey = 'Users.CustomerAddress';
    }
}